// src/api/shiftReport.api.ts
import { get, post } from './client';

export const shiftReportApi = {
  getShiftReports: (params?: {
    page?: number;
    limit?: number;
    userId?: string;
    startDate?: string;
    endDate?: string;
    status?: string;
  }) => get('/shift-reports', { params }),

  getShiftReportById: (id: string) => get(`/shift-reports/${id}`),

  generateShiftReport: (data: {
    userId: string;
    startDate: string;
    endDate: string;
    notes?: string;
  }) => post('/shift-reports/generate', data),

  getStaffList: () => get('/shift-reports/staff'),
};
